<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="num_fiscal" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nº Fiscal</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="chave" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Chave</label>
                        </div>
                    </b-col>


                    <b-col sm="6" md="1" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                          <input type="text" class="form-control" v-model="dt_inicio" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Data Inicio</label>
                        </div>

                    </b-col>

                    <b-col sm="6" md="1" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                          <input type="text" class="form-control" v-model="dt_fim" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Data Fim</label>
                        </div>
                    </b-col>


                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="emi_nome" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Razão Social Emitente</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="emi_cnpj" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CNPJ Emitente</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="des_nome" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Razão Social Destinatário</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="des_cnpj" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CNPJ Destinatário</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                            <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                          </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      num_fiscal: '',
      chave: '',
      dt_inicio: '',
      dt_fim: '',
      des_nome: '',
      emi_nome: '',
      des_cnpj: '',
      emi_cnpj: '',
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  mounted() {
      //
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {num_fiscal: this.num_fiscal,
                              chave: this.chave,
                              des_nome: this.des_nome,
                              emi_nome: this.emi_nome,
                              des_cnpj: this.des_cnpj,
                              emi_cnpj: this.emi_cnpj,
                              dt_inicio: this.dt_inicio,
                              dt_fim: this.dt_fim,
                             };
          this.$events.fire('filterModal-set', this.data_filter);
      },
      resetFilter () {
        this.num_fiscal = '';  // clear the text in text input
        this.chave = '';
        this.des_nome = '';
        this.emi_nome = '';
        this.des_cnpj = '';
        this.emi_cnpj = '';
        this.dt_inicio = '';
        this.dt_fim = '';
        this.$events.fire('filterModal-reset');
      },
      formatTypedDate: function (dateString)
      {
         let result = dateString.split('/')
         return result[2] + '-' + result[1] + '-' + result[0] + 'T00:00:00-03:00'
      }
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
